
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const PhuongPhapHocTapHieuQuaPage = () => {
  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <Header />

        {/* Breadcrumb */}
        <div className="pt-24 pb-6 px-6 bg-white border-b border-gray-200">
          <div className="max-w-5xl mx-auto">
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <Link to="/" className="hover:text-teal-600 transition-colors">Trang chủ</Link>
              <i className="ri-arrow-right-s-line"></i>
              <Link to="/tin-tuc" className="hover:text-teal-600 transition-colors">Tin tức</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-gray-900 font-semibold">Phương pháp học tập hiệu quả</span>
            </div>
          </div>
        </div>

        {/* Article Header */}
        <article className="py-12 px-6">
          <div className="max-w-5xl mx-auto">
            <div className="mb-8">
              <span className="inline-block px-4 py-2 bg-gradient-to-r from-teal-600 to-cyan-600 text-white text-sm font-semibold rounded-full mb-4">
                Phương pháp học
              </span>
              
              <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: 'Merriweather, serif' }}>
                📚 Phương Pháp Học Tập Hiệu Quả Cho Học Sinh THCS
              </h1>

              <div className="flex items-center gap-6 text-gray-600 text-sm">
                <span className="flex items-center gap-2">
                  <i className="ri-calendar-line"></i>
                  15/01/2025
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-time-line"></i>
                  8 phút đọc
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-eye-line"></i>
                  1,250 lượt xem
                </span>
              </div>
            </div>

            {/* Featured Image */}
            <div className="w-full h-96 rounded-2xl overflow-hidden mb-12">
              <img
                src="https://public.readdy.ai/ai/img_res/6426405d2647d7f3e2f718e0617a1ffa.jpg"
                alt="Phương pháp học tập hiệu quả"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Article Content */}
            <div className="prose prose-lg max-w-none">
              {/* Introduction */}
              <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-r-xl mb-8">
                <p className="text-gray-700 leading-relaxed text-base mb-0">
                  <strong>Học tập hiệu quả</strong> không chỉ là việc ngồi đọc sách nhiều giờ mà còn phải biết cách học thông minh. Bài viết này sẽ chia sẻ những phương pháp học tập khoa học, được chứng minh giúp học sinh THCS nâng cao hiệu suất học tập, ghi nhớ kiến thức lâu hơn và đạt kết quả tốt hơn trong các kỳ thi.
                </p>
              </div>

              {/* Method 1 */}
              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-teal-600 text-white rounded-lg flex items-center justify-center text-xl">1</span>
                Phương Pháp Pomodoro - Quản Lý Thời Gian Học Tập
              </h2>

              <p className="text-gray-700 leading-relaxed mb-4">
                Phương pháp Pomodoro là kỹ thuật quản lý thời gian được phát triển bởi Francesco Cirillo vào cuối những năm 1980. Đây là một trong những phương pháp học tập hiệu quả nhất hiện nay, đặc biệt phù hợp với học sinh cấp 2 khi bộ não chưa thể tập trung liên tục trong thời gian dài.
              </p>

              <div className="bg-gradient-to-r from-teal-50 to-cyan-50 p-6 rounded-xl mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <i className="ri-time-line text-teal-600"></i>
                  Cách thực hiện:
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-0.5">1</span>
                    <span><strong>Học tập 25 phút:</strong> Tập trung hoàn toàn vào một nhiệm vụ cụ thể (ví dụ: học một bài Toán, đọc một đoạn văn)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-0.5">2</span>
                    <span><strong>Nghỉ ngơi 5 phút:</strong> Đứng dậy đi lại, uống nước, thả lỏng cơ thể</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm flex-shrink-0 mt-0.5">3</span>
                    <span><strong>Lặp lại 4 lần:</strong> Sau 4 pomodoro (khoảng 2 giờ), nghỉ dài 15-30 phút</span>
                  </li>
                </ul>
              </div>

              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>Lợi ích:</strong> Giúp não bộ duy trì sự tập trung tối đa, giảm căng thẳng học tập, tránh tình trạng học quá lâu dẫn đến kiệt sức. Nghiên cứu cho thấy não người chỉ có thể tập trung hiệu quả trong khoảng 25-30 phút trước khi cần nghỉ ngơi để phục hồi.
              </p>

              {/* Method 2 */}
              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-cyan-600 text-white rounded-lg flex items-center justify-center text-xl">2</span>
                Học Chủ Động Bằng Phương Pháp Feynman
              </h2>

              <p className="text-gray-700 leading-relaxed mb-4">
                Richard Feynman - nhà vật lý thiên tài đoạt giải Nobel - đã phát triển phương pháp học tập này dựa trên nguyên lý: "Nếu bạn không thể giải thích một điều gì đó bằng ngôn ngữ đơn giản, nghĩa là bạn chưa hiểu nó thật sự." Đây là phương pháp cực kỳ hiệu quả để kiểm tra mức độ hiểu bài và củng cố kiến thức.
              </p>

              <div className="bg-gradient-to-r from-cyan-50 to-blue-50 p-6 rounded-xl mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <i className="ri-lightbulb-line text-cyan-600"></i>
                  4 Bước thực hiện:
                </h3>
                <div className="space-y-4">
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-cyan-600 text-white rounded-xl flex items-center justify-center font-bold text-lg flex-shrink-0">1</div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">Chọn khái niệm cần học</h4>
                      <p className="text-gray-700 text-sm">Viết tên khái niệm lên đầu trang giấy (ví dụ: "Quang hợp ở thực vật")</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-cyan-600 text-white rounded-xl flex items-center justify-center font-bold text-lg flex-shrink-0">2</div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">Giải thích như dạy trẻ lớp 5</h4>
                      <p className="text-gray-700 text-sm">Viết giải thích bằng ngôn ngữ đơn giản nhất, không dùng thuật ngữ phức tạp</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-cyan-600 text-white rounded-xl flex items-center justify-center font-bold text-lg flex-shrink-0">3</div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">Tìm điểm yếu và học lại</h4>
                      <p className="text-gray-700 text-sm">Chỗ nào giải thích không rõ = chỗ đó bạn chưa hiểu. Quay lại sách giáo khoa để học kỹ hơn</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-cyan-600 text-white rounded-xl flex items-center justify-center font-bold text-lg flex-shrink-0">4</div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-1">Đơn giản hóa và dùng ví dụ</h4>
                      <p className="text-gray-700 text-sm">Dùng câu chuyện, hình ảnh, so sánh để làm rõ khái niệm</p>
                    </div>
                  </div>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>Ví dụ thực tế:</strong> Thay vì ghi nhớ "Quang hợp là quá trình chuyển hóa năng lượng ánh sáng thành năng lượng hóa học", hãy giải thích: "Cây cối giống như một nhà máy nhỏ. Chúng dùng ánh sáng mặt trời, nước và không khí để tự nấu ăn cho mình, tạo ra đường và giải phóng khí oxy cho chúng ta thở."
              </p>

              {/* Method 3 */}
              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-blue-600 text-white rounded-lg flex items-center justify-center text-xl">3</span>
                Sử Dụng Sơ Đồ Tư Duy (Mind Map)
              </h2>

              <p className="text-gray-700 leading-relaxed mb-4">
                Sơ đồ tư duy là công cụ trực quan hóa kiến thức cực kỳ mạnh mẽ, được phát triển bởi Tony Buzan. Phương pháp này khai thác cách hoạt động tự nhiên của não bộ - liên kết thông tin theo mạng lưới thay vì theo danh sách tuyến tính. Đặc biệt hiệu quả cho các môn có nhiều khái niệm cần ghi nhớ như Sinh học, Lịch sử, Địa lý.
              </p>

              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <i className="ri-mind-map text-blue-600"></i>
                  Hướng dẫn vẽ Mind Map hiệu quả:
                </h3>
                <div className="grid md:grid-cols-2 gap-4 text-sm">
                  <div className="bg-white p-4 rounded-lg">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-lg flex items-center justify-center mb-2">
                      <i className="ri-focus-2-line"></i>
                    </div>
                    <h4 className="font-bold text-gray-900 mb-2">Chủ đề trung tâm</h4>
                    <p className="text-gray-700">Viết/vẽ chủ đề chính ở giữa trang, dùng hình ảnh hoặc màu sắc nổi bật</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-lg flex items-center justify-center mb-2">
                      <i className="ri-git-branch-line"></i>
                    </div>
                    <h4 className="font-bold text-gray-900 mb-2">Nhánh chính</h4>
                    <p className="text-gray-700">Vẽ 3-7 nhánh to từ trung tâm ra, mỗi nhánh là một ý chính</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-lg flex items-center justify-center mb-2">
                      <i className="ri-palette-line"></i>
                    </div>
                    <h4 className="font-bold text-gray-900 mb-2">Màu sắc &amp; hình ảnh</h4>
                    <p className="text-gray-700">Mỗi nhánh dùng một màu khác nhau, thêm icon/hình vẽ để dễ nhớ</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg">
                    <div className="w-8 h-8 bg-blue-600 text-white rounded-lg flex items-center justify-center mb-2">
                      <i className="ri-text text-blue-600"></i>
                    </div>
                    <h4 className="font-bold text-gray-900 mb-2">Từ khóa ngắn gọn</h4>
                    <p className="text-gray-700">Chỉ viết 1-2 từ trên mỗi nhánh, không viết câu dài</p>
                  </div>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>Lợi ích khoa học:</strong> Nghiên cứu từ đại học Johns Hopkins cho thấy học sinh sử dụng Mind Map ghi nhớ tốt hơn 32% so với ghi chép truyền thống. Lý do là phương pháp này kích hoạt đồng thời cả não trái (logic) và não phải (sáng tạo), tạo nhiều "điểm neo" trong trí nhớ hơn.
              </p>

              {/* Method 4 */}
              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-purple-600 text-white rounded-lg flex items-center justify-center text-xl">4</span>
                Kỹ Thuật Lặp Lại Ngắt Quãng (Spaced Repetition)
              </h2>

              <p className="text-gray-700 leading-relaxed mb-4">
                Đây là phương pháp ghi nhớ dựa trên đường cong망각 của Ebbinghaus - nhà tâm lý học người Đức. Ông phát hiện ra rằng chúng ta quên 50% thông tin mới chỉ sau 1 giờ, và 70% sau 24 giờ nếu không ôn lại. Kỹ thuật lặp lại ngắt quãng giúp chống lại hiện tượng này một cách khoa học.
              </p>

              <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-xl mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <i className="ri-calendar-check-line text-purple-600"></i>
                  Lịch ôn tập tối ưu:
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center gap-4 bg-white p-4 rounded-lg">
                    <div className="w-16 h-16 bg-purple-600 text-white rounded-xl flex items-center justify-center font-bold flex-shrink-0">
                      <div className="text-center">
                        <div className="text-xs">Lần</div>
                        <div className="text-2xl">1</div>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="font-bold text-gray-900">Học lần đầu</div>
                      <div className="text-sm text-gray-600">Tập trung học kỹ, ghi chép đầy đủ</div>
                    </div>
                    <div className="text-purple-600 font-bold">Hôm nay</div>
                  </div>

                  <div className="flex items-center gap-4 bg-white p-4 rounded-lg">
                    <div className="w-16 h-16 bg-purple-600 text-white rounded-xl flex items-center justify-center font-bold flex-shrink-0">
                      <div className="text-center">
                        <div className="text-xs">Lần</div>
                        <div className="text-2xl">2</div>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="font-bold text-gray-900">Ôn lại nhanh</div>
                      <div className="text-sm text-gray-600">Đọc lại ghi chép, nhớ lại những gì đã học</div>
                    </div>
                    <div className="text-purple-600 font-bold">+1 ngày</div>
                  </div>

                  <div className="flex items-center gap-4 bg-white p-4 rounded-lg">
                    <div className="w-16 h-16 bg-purple-600 text-white rounded-xl flex items-center justify-center font-bold flex-shrink-0">
                      <div className="text-center">
                        <div className="text-xs">Lần</div>
                        <div className="text-2xl">3</div>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="font-bold text-gray-900">Ôn sâu hơn</div>
                      <div className="text-sm text-gray-600">Làm bài tập, tự test kiến thức</div>
                    </div>
                    <div className="text-purple-600 font-bold">+3 ngày</div>
                  </div>

                  <div className="flex items-center gap-4 bg-white p-4 rounded-lg">
                    <div className="w-16 h-16 bg-purple-600 text-white rounded-xl flex items-center justify-center font-bold flex-shrink-0">
                      <div className="text-center">
                        <div className="text-xs">Lần</div>
                        <div className="text-2xl">4</div>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="font-bold text-gray-900">Củng cố</div>
                      <div className="text-sm text-gray-600">Ôn lại tổng quát, liên hệ với kiến thức khác</div>
                    </div>
                    <div className="text-purple-600 font-bold">+7 ngày</div>
                  </div>

                  <div className="flex items-center gap-4 bg-white p-4 rounded-lg">
                    <div className="w-16 h-16 bg-purple-600 text-white rounded-xl flex items-center justify-center font-bold flex-shrink-0">
                      <div className="text-center">
                        <div className="text-xs">Lần</div>
                        <div className="text-2xl">5</div>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="font-bold text-gray-900">Ôn dài hạn</div>
                      <div className="text-sm text-gray-600">Kiểm tra trước kỳ thi</div>
                    </div>
                    <div className="text-purple-600 font-bold">+14 ngày</div>
                  </div>
                </div>
              </div>

              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>Thực tế:</strong> Các ứng dụng như Anki, Quizlet đều áp dụng nguyên lý này. Nhưng bạn có thể tự làm bằng cách viết flashcard và sắp xếp theo hộp (Hộp 1: ôn hàng ngày, Hộp 2: ôn 3 ngày/lần, Hộp 3: ôn 1 tuần/lần...). Thẻ nào thuộc rồi chuyển sang hộp tiếp theo, thẻ nào quên thì đưa về Hộp 1.
              </p>

              {/* Method 5 */}
              <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-green-600 text-white rounded-lg flex items-center justify-center text-xl">5</span>
                Học Nhóm Hiệu Quả
              </h2>

              <p className="text-gray-700 leading-relaxed mb-4">
                Học nhóm không phải là ngồi tụ tập để làm bài cùng nhau. Học nhóm hiệu quả là khi mỗi người đóng góp, tranh luận, giải thích cho nhau hiểu. Nghiên cứu từ Stanford cho thấy học sinh học nhóm đúng cách có điểm trung bình cao hơn 12% so với học một mình.
              </p>

              <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-xl mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <i className="ri-team-line text-green-600"></i>
                  Nguyên tắc học nhóm hiệu quả:
                </h3>
                <div className="space-y-4">
                  <div className="bg-white p-4 rounded-lg">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-green-600 text-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-number-1"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">Chọn đúng thành viên (3-5 người)</h4>
                        <p className="text-gray-700 text-sm">Tìm bạn có mục tiêu học tập rõ ràng, trình độ tương đương. Tránh nhóm quá đông hoặc chênh lệch trình độ quá nhiều.</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white p-4 rounded-lg">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-green-600 text-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-number-2"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">Chuẩn bị trước khi gặp</h4>
                        <p className="text-gray-700 text-sm">Mỗi người tự học trước, ghi chú những chỗ khó hiểu. Đến buổi học nhóm là để thảo luận, không phải để ngồi đọc sách lần đầu.</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white p-4 rounded-lg">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-green-600 text-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-number-3"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">Phân công rõ ràng</h4>
                        <p className="text-gray-700 text-sm">Mỗi người phụ trách giải thích một phần. Ví dụ: bạn A giảng bài 1, bạn B giảng bài 2, sau đó cùng thảo luận.</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white p-4 rounded-lg">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-green-600 text-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-number-4"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">Tạo câu hỏi cho nhau</h4>
                        <p className="text-gray-700 text-sm">Luân phiên đặt câu hỏi khó. Người giải thích được = người hiểu sâu nhất.</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white p-4 rounded-lg">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-green-600 text-white rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className="ri-number-5"></i>
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-1">Giới hạn thời gian</h4>
                        <p className="text-gray-700 text-sm">Mỗi buổi 1.5-2 giờ là đủ. Quá lâu dễ mất tập trung và trở thành buổi tán gẫu.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Summary */}
              <div className="bg-gradient-to-r from-orange-50 to-amber-50 border-l-4 border-orange-600 p-6 rounded-r-xl mt-12">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <i className="ri-lightbulb-flash-line text-orange-600"></i>
                  Tổng Kết &amp; Lưu Ý Quan Trọng
                </h3>
                <div className="space-y-3 text-gray-700">
                  <p className="flex items-start gap-2">
                    <i className="ri-check-line text-orange-600 mt-1 flex-shrink-0"></i>
                    <span><strong>Không có phương pháp "thần thánh":</strong> Mỗi người khác nhau, hãy thử nghiệm và tìm cách học phù hợp với bản thân.</span>
                  </p>
                  <p className="flex items-start gap-2">
                    <i className="ri-check-line text-orange-600 mt-1 flex-shrink-0"></i>
                    <span><strong>Kết hợp nhiều phương pháp:</strong> Dùng Pomodoro để quản lý thời gian, Feynman để hiểu sâu, Mind Map để ghi nhớ, Spaced Repetition để ôn tập.</span>
                  </p>
                  <p className="flex items-start gap-2">
                    <i className="ri-check-line text-orange-600 mt-1 flex-shrink-0"></i>
                    <span><strong>Chất lượng &gt; Số lượng:</strong> Học 1 giờ hiệu quả tốt hơn học 3 giờ mà không tập trung.</span>
                  </p>
                  <p className="flex items-start gap-2">
                    <i className="ri-check-line text-orange-600 mt-1 flex-shrink-0"></i>
                    <span><strong>Ngủ đủ giấc:</strong> Não cần 8-9 giờ ngủ mỗi đêm để củng cố trí nhớ. Thức khuya học sẽ phản tác dụng.</span>
                  </p>
                  <p className="flex items-start gap-2">
                    <i className="ri-check-line text-orange-600 mt-1 flex-shrink-0"></i>
                    <span><strong>Kiên trì:</strong> Phương pháp mới cần 2-3 tuần để hình thành thói quen. Đừng bỏ cuộc quá sớm!</span>
                  </p>
                </div>
              </div>
            </div>

            {/* Related Articles */}
            <div className="mt-16 pt-8 border-t border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">📖 Bài viết liên quan</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <Link
                  to="/tin-tuc"
                  className="bg-gradient-to-br from-teal-50 to-cyan-50 p-6 rounded-xl hover:shadow-lg transition-all cursor-pointer"
                >
                  <div className="w-12 h-12 bg-teal-600 text-white rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-book-open-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">Mẹo ghi nhớ công thức</h4>
                  <p className="text-sm text-gray-600">Kỹ thuật nhớ nhanh các công thức Toán - Lý - Hóa</p>
                </Link>

                <Link
                  to="/tin-tuc"
                  className="bg-gradient-to-br from-cyan-50 to-blue-50 p-6 rounded-xl hover:shadow-lg transition-all cursor-pointer"
                >
                  <div className="w-12 h-12 bg-cyan-600 text-white rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-edit-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">Làm bài thi trắc nghiệm</h4>
                  <p className="text-sm text-gray-600">Chiến lược làm bài đạt điểm cao</p>
                </Link>

                <Link
                  to="/tin-tuc"
                  className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-xl hover:shadow-lg transition-all cursor-pointer"
                >
                  <div className="w-12 h-12 bg-blue-600 text-white rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-calendar-check-line text-2xl"></i>
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2">Chuẩn bị kỳ thi</h4>
                  <p className="text-sm text-gray-600">Lộ trình ôn tập chi tiết và hiệu quả</p>
                </Link>
              </div>
            </div>
          </div>
        </article>

        <Footer />
      </div>
    </>
  );
};

export default PhuongPhapHocTapHieuQuaPage;
